import type { HTMLProps } from 'react'
import clsx from 'classnames'
import { Text } from '@/shared/ui'
import { itemVariants } from '@/shared/utils'
import { EventHeader } from '@/shared/ui/event-header'
import { IEventPreview } from '@/interfaces/events'
import { MotionLink } from '@/shared/ui/link'
import style from './event-card.module.scss'

interface EventCardProps extends Omit<HTMLProps<HTMLDivElement>, 'id' | 'title'>, IEventPreview {}

export const EventCard = (props: EventCardProps) => {
  const { className, category, date_start, date_end, location, title, slug } = props

  return (
    <MotionLink className={clsx(className, style.container)} href={`/events/${slug}`} variants={itemVariants}>
      <EventHeader
        className={style.header}
        category={category}
        date={date_start ?? date_end}
        location={location}
        light
      />
      <Text className={style.text} type="t1" color="dark" tagName="p">
        {title}
      </Text>
    </MotionLink>
  )
}
